<template>
  <router-view />
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("operations");
import { notifySystemError } from "@/utils/operations";

/**
 * Operationのマスタデータを取得するコンポーネント
 * クライアントでキャッシュしてない場合のみAPIで取得する
 */
export default {
  name: "MasterDataFetcherIfNotStored",
  methods: {
    ...mapActions(["setOperationCommonConfigurationFromLocalDBAndAPI"]),
    async setMasterData() {
      try {
        await Promise.all([
          this.setOperationCommonConfigurationFromLocalDBAndAPI(),
        ]);
      } catch (_e) {
        notifySystemError(this);
      }
    },
  },

  created() {
    this.setMasterData();
  },
};
</script>
